/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Firstsubjectgraduationcoursetype4Inputs */

const de__field_firstsubjectgraduationcoursetype4 = /** @type {(inputs: _Field_Firstsubjectgraduationcoursetype4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstfach Kursart`)
};

/**

* @param {_Field_Firstsubjectgraduationcoursetype4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_firstsubjectgraduationcoursetype4 = /** @type {((inputs?: _Field_Firstsubjectgraduationcoursetype4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Firstsubjectgraduationcoursetype4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_firstsubjectgraduationcoursetype4(inputs)
});
export { _field_firstsubjectgraduationcoursetype4 as "_field_firstSubjectGraduationCourseType" }